import { AiVideoGenerationNotification } from '../domain';

export function getAiVideoGenerationTitle(
  notification: AiVideoGenerationNotification
): string {
  const model = notification.content.metadata.model ?? '';
  return `Video generation - ${model}`;
}

export function getAiVideoGenerationDescriptionContent(
  notification: AiVideoGenerationNotification
): string {
  return notification.content.metadata['error'] ? 'Failed' : 'Success';
}
